module.exports = __webpack_public_path__ + "img/2025-05-09c_4.4e0c1ba0.jpg";